import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const loadInvitationsAction = factory<{ activityId: string; applicationKey: string }>("LOAD_INVITATIONS");

export interface ConfirmResponsePayload {
	confirmed: boolean;
}

export const confirmResponse = factory<ConfirmResponsePayload>("CONFIRM_RESPONSE");
